import React from "react";
import PageTitle from "../Dashboard/PageTitle";
import "../Dashboard/main.css";
import MomentumTrackContainer from "./MomentumTrackContainer";

function MomentumTrackmain() {
  return (
    <main id="main" className="main">
      <PageTitle page={"MomentumTrack"} />
      <MomentumTrackContainer />
    </main>
  );
}

export default MomentumTrackmain;
